import React, {useState, useEffect} from 'react';
import {Table} from 'antd';
import http from '../../services/httpService';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useHistory} from 'react-router-dom';
import {Spinner} from 'react-bootstrap';
import {t} from 'react-switch-lang';
import './customTable.scss';
import {courtRiskId, incurredRiskId, potentialRiskId} from "../../utils/const";

/**
 *
 * @param {object} props
 * @param {string} props.api 'Endpoint for fetching table data'
 * @param {array} props.columns 'Columns structure'
 * @param {integer} [props.rows=20] 'Number of rows to fetch'
 * @param {callback} [props.onRowClick] 'Callback function that takes record, rowIndex and click event parameters'
 */
const NoFormTable = ({
  api,
  query,
  queryParamName,
  columns,
  rows = 20,
  onRowClick,
  ...rest
}) => {
  const [items, setItems] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(0);
  const history = useHistory();

  query = query
    ? queryParamName
      ? `${queryParamName}=${query}`
      : `name.contains=${query}`
    : '';

  const fetchData = async () => {
    try {
      if (api.includes('?') || api.includes('size')) {
        const {data} = await http.get(`${api}`);
        setItems(data);
        setHasMore(data.length === rows);
        setPage(1);
      } else {
        const {data} = await http.get(`${api}?page=0&size=${rows}&${query}`);
        setItems(data);
        setHasMore(data.length === rows);
        setPage(1);
      }
    } catch (err) {}
  };
  // const fetchMoreData = async () => {
  //   try {
  //     const {data} = await http.get(
  //       `${api}?page=${page}&size=${rows}&${query}`
  //     );
  //     setItems([...items, ...data]);
  //     setHasMore(data.length === rows);
  //     setPage((page) => page + 1);
  //   } catch (err) {}
  // };

  useEffect(() => {
    if (api !== undefined && api !== '') {
      fetchData();
    }
  }, [api, query]);

  const mergedColumns = columns.map((col) => {
    if (!col.editable) return col;

    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: col.inputType,
        dataIndex: col.dataIndex,
        title: col.title,
        rules: col.rules,
        options: col.options,
        disabled: col.disabled,
        min: col.min,
        max: col.max,
        placeholder: col.placeholder,
      }),
    };
  });
  const loader = (
    <div className="text-center mt-3">
      <Spinner variant="primary" animation="border" />
    </div>
  );

  return (
    <InfiniteScroll
      // next={fetchMoreData}
      hasMore={hasMore}
      loader={loader}
      scrollableTarget="app-body"
      dataLength={items.length}
    >
      <Table
        style={{cursor: 'pointer'}}
        onRow={(record, rowIndex) => {
          return {
            onClick: () =>
              onRowClick
                ? onRowClick(record.id)
                : record.riskTypeId === incurredRiskId
                ? history.push(`/incurred-risk/${record.id}`)
                : record.riskTypeId ===
                  potentialRiskId
                ? history.push(`/potential-risk/${record.id}`)
                : record.riskTypeId === courtRiskId
                ? history.push(`/court-risk/${record.courtRiskId}`)
                : null,
          };
        }}
        columns={mergedColumns}
        dataSource={items}
        pagination={false}
        sticky={true}
        rowKey={(record) => record.id}
        locale={{emptyText: t('common.noData')}}
        scroll={{x: '100%'}}
        {...rest}
      />
    </InfiniteScroll>
  );
};

export default NoFormTable;
